import React from "react";
export const ColorQuestionContext = React.createContext();
